import { CollectionEndpoints } from '@/modules/page/collection/api/collectionEndpoints'

/**
 * Collection endpoint instance
 * instantiate collection api class with different api path
 */
export const collectionEndpoints = new CollectionEndpoints()
